import React from 'react';
import './App.css';
import HomeScreen from './HomeScreen';
import {BrowserRouter as Router,Routes,Route} from "react-router-dom";

function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/test">
          <h1>Wow Whats up</h1>
          </Route>
          <Route path="/">
          <HomeScreen />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
